/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Pricing information for a borrower contract loan
 * @export
 * @interface BorrowerContractPricingDto
 */
export interface BorrowerContractPricingDto {
    /**
     * Monthly premium amount
     * @type {number}
     * @memberof BorrowerContractPricingDto
     */
    monthPrice?: number;
    /**
     * Total price over eight years
     * @type {number}
     * @memberof BorrowerContractPricingDto
     */
    totalPriceEightYears?: number;
    /**
     * Average insurance rate
     * @type {number}
     * @memberof BorrowerContractPricingDto
     */
    averageRate?: number;
    /**
     * Discount amount
     * @type {number}
     * @memberof BorrowerContractPricingDto
     */
    discountPrice?: number;
    /**
     * Discount percentage
     * @type {number}
     * @memberof BorrowerContractPricingDto
     */
    discountPercentage?: number;
    /**
     * Price before discount
     * @type {number}
     * @memberof BorrowerContractPricingDto
     */
    initialPrice?: number;
    /**
     * Final price after discount
     * @type {number}
     * @memberof BorrowerContractPricingDto
     */
    finalPrice?: number;
}

/**
 * Check if a given object implements the BorrowerContractPricingDto interface.
 */
export function instanceOfBorrowerContractPricingDto(value: object): value is BorrowerContractPricingDto {
    return true;
}

export function BorrowerContractPricingDtoFromJSON(json: any): BorrowerContractPricingDto {
    return BorrowerContractPricingDtoFromJSONTyped(json, false);
}

export function BorrowerContractPricingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerContractPricingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'monthPrice': json['monthPrice'] == null ? undefined : json['monthPrice'],
        'totalPriceEightYears': json['totalPriceEightYears'] == null ? undefined : json['totalPriceEightYears'],
        'averageRate': json['averageRate'] == null ? undefined : json['averageRate'],
        'discountPrice': json['discountPrice'] == null ? undefined : json['discountPrice'],
        'discountPercentage': json['discountPercentage'] == null ? undefined : json['discountPercentage'],
        'initialPrice': json['initialPrice'] == null ? undefined : json['initialPrice'],
        'finalPrice': json['finalPrice'] == null ? undefined : json['finalPrice'],
    };
}

export function BorrowerContractPricingDtoToJSON(json: any): BorrowerContractPricingDto {
    return BorrowerContractPricingDtoToJSONTyped(json, false);
}

export function BorrowerContractPricingDtoToJSONTyped(value?: BorrowerContractPricingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monthPrice': value['monthPrice'],
        'totalPriceEightYears': value['totalPriceEightYears'],
        'averageRate': value['averageRate'],
        'discountPrice': value['discountPrice'],
        'discountPercentage': value['discountPercentage'],
        'initialPrice': value['initialPrice'],
        'finalPrice': value['finalPrice'],
    };
}

